<p-columnFilter [field]=field display="menu" #filterId [showAddButton]="false" [showMatchModes]="false" matchMode="custom-equals"
    [showOperator]="false" [showClearButton]="false" [showApplyButton]="false"
    (click)="filterOpen(filterFormGroup, field, 'matchModeControl', 'valueControl');">
    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
        <form [formGroup]="filterFormGroup" (keydown.enter)="apply(filterFormGroup, field);filterId.hide()">
            <p-dropdown [options]="matchModeOptions" formControlName="matchModeControl" optionLabel="label"
                optionValue="value"></p-dropdown>
            <p-dropdown [options]="values" formControlName="valueControl" [optionLabel]="optionLabel" styleClass="mt-1"
                [optionValue]="optionValue"></p-dropdown>
            <div class="d-flex justify-content-around mt-3">
                <button type="button" class="btn btn-danger btn-sm column-filter-btn" pRipple
                    (click)="clear(field);filterId.hide();initialSetup()">Clear</button>
                <button type="button" class="btn btn-success btn-sm column-filter-btn" pRipple
                    (click)="apply(filterFormGroup, field);filterId.hide()">Apply</button>
            </div>
        </form>
    </ng-template>
</p-columnFilter>